import _ from "lodash";
import shortid from "shortid";
import { getAppConfig } from "config/client.config";

export const CREATE_DECK = "CREATE_DECK";
export const CLEAR_DECK = "CLEAR_DECK";
export const UPDATE_DECK = "UPDATE_DECK";
export const LOAD_DECK = "LOAD_DECK";
export const FETCH_IMAGES = "FETCH_IMAGES";
export const EDITOR_RENAME_DECK = "EDITOR_RENAME_DECK";
export const ADD_SLIDE = "ADD_SLIDE";
export const DUPLICATE_SLIDE = "DUPLICATE_SLIDE";
export const RESET_SLIDE = "RESET_SLIDE";
export const DELETE_SLIDE = "DELETE_SLIDE";
export const CHANGE_TEMPLATE = "CHANGE_TEMPLATE";
export const CHANGE_NAV = "CHANGE_NAV";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const CHANGE_MINTIME = "CHANGE_MINTIME";
export const ADD_POINTS = "ADD_POINTS";
export const ADD_COINS = "ADD_COINS";
export const FETCH_AUDIOS = "FETCH_AUDIOS";
export const FETCH_DOCS = "FETCH_DOCS";
export const ADD_QUIZ_SETTINGS = "ADD_QUIZ_SETTINGS";
export const UPLOAD_SLIDES = "UPLOAD_SLIDES";
export const ADD_GAME_TYPE = "ADD_GAME_TYPE";

const _createDeck = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: CREATE_DECK, data, err, status };
};
const _clearDeck = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: CLEAR_DECK, data, err, status };
};
const _updateDeck = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: UPDATE_DECK, data, err, status };
};
const _renameDeck = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: EDITOR_RENAME_DECK, data, err, status };
};
const _loadDeck = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: LOAD_DECK, data, err, status };
};
const _fetchImages = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return {
        type: FETCH_IMAGES,
        data,
        err,
        status,
    };
};
const _addSlide = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: ADD_SLIDE, data, err, status };
};
const _duplicateSlide = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: DUPLICATE_SLIDE, data, err, status };
};
const _resetSlide = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: RESET_SLIDE, data, err, status };
};
const _deleteSlide = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: DELETE_SLIDE, data, err, status };
};
const _changeTemplate = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: CHANGE_TEMPLATE, data, err, status };
};
const _changeNav = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: CHANGE_NAV, data, err, status };
};
const _changeLanguage = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: CHANGE_LANGUAGE, data, err, status };
};
const _changeMinTime = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: CHANGE_MINTIME, data, err, status };
};

const _addPoints = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: ADD_POINTS, data, err, status };
};
const _addCoins = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: ADD_COINS, data, err, status };
};

const _fetchAudio = (status, data, err) => {
    // Used to trigger updates in DeckAttempt reducer
    return {
        type: FETCH_AUDIOS,
        data,
        err,
        status,
    };
};

const _fetchDocs = (status, data, err) => {
    // Used to trigger updates in DeckAttempt reducer
    return {
        type: FETCH_DOCS,
        data,
        err,
        status,
    };
};

const _addQuizSettings = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: ADD_QUIZ_SETTINGS, data, err, status };
};

const _uploadSlides = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: UPLOAD_SLIDES, data, err, status };
};

const _addGameType = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: ADD_GAME_TYPE, data, err, status };
};

const createDeck = /* istanbul ignore next - redux passthrough function */ (
    name,
    readerType,
    contentHash
) => {
    return (dispatch) => {
        let adjContentHash = contentHash;
        _.each(adjContentHash, (row, idx) => {
            row.id = shortid.generate();
        });
        return Promise.resolve(
            dispatch(
                _createDeck(
                    "creating",
                    {
                        name: name,
                        readerType: readerType,
                        contentHash: adjContentHash,
                        shortid: {
                            deckId: shortid.generate(),
                            firstSlideId: shortid.generate(),
                        },
                    },
                    null
                )
            )
        );
    };
};

const clearDeck = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch) => {
        return Promise.resolve(dispatch(_clearDeck("clearing", null, null)));
    };
};
const updateDeck = /* istanbul ignore next - redux passthrough function */ (
    data
) => {
    return (dispatch) => {
        return Promise.resolve(dispatch(_updateDeck("updating", data, null)));
    };
};

const loadDeck = /* istanbul ignore next - redux passthrough function */ (
    id
) => {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            getAppConfig().endpoints.contentPaths["getDeckPath"].replace(
                ":id",
                id
            )
        )
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(
                        dispatch(_loadDeck("opening", data, null))
                    );
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const addImagesToLibrary = (contentHash) => {
    let result = [];
    if (contentHash instanceof Array) {
        for (var i = 0; i < contentHash.length; i++) {
            result.push(addImagesToLibrary(contentHash[i]));
        }
    } else {
        let sectionResult = [];
        for (var prop in contentHash) {
            if (prop === "presenter") {
                sectionResult.push(
                    contentHash.presenter.id + contentHash.presenter.extension
                );
            }
            if (prop === "image") {
                sectionResult.push(
                    contentHash.image.id + contentHash.image.extension
                );
            }
            if (prop === "background") {
                sectionResult.push(
                    contentHash.background.id + contentHash.background.extension
                );
            }
            if (
                contentHash[prop] instanceof Object ||
                contentHash[prop] instanceof Array
            )
                sectionResult.push(addImagesToLibrary(contentHash[prop]));
        }
        if (sectionResult.length > 0) return sectionResult;
    }
    return _.flatten(result);
};

const fetchImageLibrary = () => {
    return (dispatch, getState, Request) => {
        let imageList = _.flatten(
            _.filter(
                _.uniq(
                    _.flatten(
                        addImagesToLibrary(getState().deckAttempt.content)
                    )
                ),
                (imgId) => {
                    return (
                        imgId !== "default11.jpeg" &&
                        imgId !== "default43.png" &&
                        imgId !== "default133.png" &&
                        imgId !== "default169.png"
                    );
                }
            )
        );
        if (imageList.length > 0) {
            _.each(imageList, (srcImg) => {
                let img = Array.isArray(srcImg)
                    ? srcImg[0]
                    : typeof srcImg === "object"
                    ? srcImg["image"]
                    : srcImg;
                if (img !== undefined) {
                    let readerURL =
                        getState().deckAttempt.readerType === "qdf"
                            ? "public/qdf/slides/"
                            : "public/quiz/";
                    let url = getAppConfig().apiUrls.assetUrl.endsWith("/")
                        ? getAppConfig().apiUrls.assetUrl + readerURL + img
                        : getAppConfig().apiUrls.assetUrl +
                          "/" +
                          readerURL +
                          img;
                    getDataURL(url)
                        .then((data) => {
                            return dispatch(
                                _fetchImages(
                                    "success",
                                    {
                                        id: srcImg.split(".")[0],
                                        image: data,
                                    },
                                    null
                                )
                            );
                        })
                        .catch((err) => {
                            console.log(err);
                            return dispatch(_fetchImages("error", null, err));
                        });
                }
            });
            return Promise.resolve(0);
        } else {
            return Promise.resolve(0);
        }
    };
};

const renameDeck = /* istanbul ignore next - redux passthrough function */ (
    name
) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch(_renameDeck("updating", { name: name }, null))
        );
    };
};

const addSlide = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(
                _addSlide(
                    "Adding Slide",
                    {
                        slideId: shortid.generate(),
                    },
                    null
                )
            )
        );
    };
};

const duplicateSlide = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(
                _duplicateSlide(
                    "Duplicating Slide",
                    {
                        slideId: shortid.generate(),
                    },
                    null
                )
            )
        );
    };
};

const resetSlide = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(_resetSlide("Resetting Slide", {}, null))
        );
    };
};

const deleteSlide = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(_deleteSlide("Deleting Slide", {}, null))
        );
    };
};

const changeTemplate = /* istanbul ignore next - redux passthrough function */ (
    newTemplate
) => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(
                _changeTemplate(
                    "Changing Template",
                    { newTemplate: newTemplate },
                    null
                )
            )
        );
    };
};

const changeSlideNav = /* istanbul ignore next - redux passthrough function */ (
    navObj
) => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(_changeNav("Changing Navigation", { nav: navObj }, null))
        );
    };
};

const changeLanguage = /* istanbul ignore next - redux passthrough function */ (
    langCode
) => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(
                _changeLanguage(
                    "Changing Language",
                    { language: langCode },
                    null
                )
            )
        );
    };
};

const changeMinTime = /* istanbul ignore next - redux passthrough function */ (
    minTime
) => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(
                _changeMinTime("Changing Min Time", { minTime: minTime }, null)
            )
        );
    };
};

const uploadDeck = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch, getState, Request) => {
        let currentDeck = JSON.parse(JSON.stringify(getState().deck));
        let uploadedDeck = JSON.stringify(currentDeck).replace(
            '"id"',
            '"shortId"'
        );
        return Request.fetch(getAppConfig().endpoints.uploadQDFPath, {
            body: uploadedDeck,
            method: "POST",
        })
            .then(() => {
                console.log("Success");
            })
            .catch(() => {
                console.log("Failure");
            });
    };
};

const addPoints = /* istanbul ignore next - redux passthrough function */ (
    points
) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch(_addPoints("Adding points", { points: points }, null))
        );
    };
};

const addCoins = /* istanbul ignore next - redux passthrough function */ (
    coins
) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch(_addCoins("Adding coins", { coins: coins }, null))
        );
    };
};

const addAudiosToLibrary = (contentHash) => {
    let result = [];
    if (contentHash instanceof Array) {
        for (var i = 0; i < contentHash.length; i++) {
            let audio = contentHash[i].voiceover;
            if (audio && audio.id !== "") result.push(audio);
        }
    }
    return _.flatten(result);
};

const fetchAudioLibrary = (deckId) => {
    return (dispatch, getState, Request) => {
        let audioList = _.flatten(addAudiosToLibrary(getState().deck.content));

        let newaudios = [];
        if (audioList.length > 0) {
            for (let i = 0; i < audioList.length; i++) {
                let audio = audioList[i];
                if (audio !== undefined) {
                    let url = getAppConfig().apiUrls.assetUrl.endsWith("/")
                        ? `${
                              getAppConfig().apiUrls.assetUrl
                          }public/qdf/voiceovers/${deckId}/${audio.id}${
                              audio.extension
                          }`
                        : `${
                              getAppConfig().apiUrls.assetUrl
                          }/public/qdf/voiceovers/${deckId}/${audio.id}${
                              audio.extension
                          }`;
                    getDataURL(url)
                        .then((data) => {
                            newaudios.push({
                                id: audio.id,
                                audio: data,
                            });
                            if (newaudios.length === audioList.length)
                                dispatch(
                                    _fetchAudio(
                                        "success",
                                        _.uniqBy(newaudios, "id"),
                                        null
                                    )
                                );
                        })
                        .catch((err) => {
                            console.log(err);
                            return dispatch(_fetchAudio("error", null, err));
                        });
                }
            }
            return Promise.resolve(0);
        } else {
            return Promise.resolve(0);
        }
    };
};

const addDocsToLibrary = (contentHash) => {
    let result = [];
    if (contentHash instanceof Array) {
        for (var i = 0; i < contentHash.length; i++) {
            let doc = contentHash[i].data.pdf;
            if (doc && doc.id !== "") result.push(doc);
        }
    }
    return _.flatten(result);
};

const fetchDocLibrary = (deckId) => {
    return (dispatch, getState, Request) => {
        let docsList = _.flatten(addDocsToLibrary(getState().deck.content));

        let newdocs = [];
        if (docsList.length > 0) {
            for (let i = 0; i < docsList.length; i++) {
                let doc = docsList[i];
                if (doc !== undefined) {
                    let url = getAppConfig().apiUrls.assetUrl.endsWith("/")
                        ? `${
                              getAppConfig().apiUrls.assetUrl
                          }public/qdf/documents/${deckId}/${doc.id}${
                              doc.extension
                          }`
                        : `${
                              getAppConfig().apiUrls.assetUrl
                          }/public/qdf/documents/${deckId}/${doc.id}${
                              doc.extension
                          }`;
                    getDataURL(url)
                        .then((data) => {
                            newdocs.push({
                                id: doc.id,
                                doc: data,
                            });
                            if (newdocs.length === docsList.length)
                                dispatch(
                                    _fetchDocs(
                                        "success",
                                        _.uniqBy(newdocs, "id"),
                                        null
                                    )
                                );
                        })
                        .catch((err) => {
                            console.log(err);
                            return dispatch(_fetchDocs("error", null, err));
                        });
                }
            }
            return Promise.resolve(0);
        } else {
            return Promise.resolve(0);
        }
    };
};

const getDataURL = (file) => {
    return new Promise(async (resolve, reject) => {
        try {
            let response = await fetch(file);
            let data = await response.blob();
            var reader = new FileReader();
            reader.onloadend = function() {
                return resolve(reader.result);
            };
            reader.readAsDataURL(data);
        } catch (e) {
            return reject();
        }
    });
};

const addQuizSettings = /* istanbul ignore next - redux passthrough function */ (
    quizSettings
) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch(
                _addQuizSettings(
                    "Adding quiz settings",
                    {
                        points: quizSettings.points,
                        coins: quizSettings.coins,
                        passPercent: quizSettings.passPercent,
                        qcount: quizSettings.qCount,
                        isFinal: quizSettings.isFinal,
                        accessTime: quizSettings.accessTime,
                    },
                    null
                )
            )
        );
    };
};

const uploadSlides = /* istanbul ignore next - redux passthrough function */ (
    content
) => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(
                _uploadSlides(
                    "Adding Question Slides",
                    {
                        slideId: shortid.generate(),
                        content: content,
                    },
                    null
                )
            )
        );
    };
};

const addGameType = /* istanbul ignore next - redux passthrough function */ (
    selectedGame
) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch(
                _addGameType("Adding game", { quo_game: selectedGame }, null)
            )
        );
    };
};
class DeckEditorAction {
    static createDeck = createDeck;
    static clearDeck = clearDeck;
    static updateDeck = updateDeck;
    static loadDeck = loadDeck;
    static fetchImageLibrary = fetchImageLibrary;
    static renameDeck = renameDeck;
    static addSlide = addSlide;
    static duplicateSlide = duplicateSlide;
    static resetSlide = resetSlide;
    static deleteSlide = deleteSlide;
    static changeTemplate = changeTemplate;
    static changeLanguage = changeLanguage;
    static changeSlideNav = changeSlideNav;
    static changeMinTime = changeMinTime;
    static uploadDeck = uploadDeck;
    static addPoints = addPoints;
    static addCoins = addCoins;
    static fetchAudioLibrary = fetchAudioLibrary;
    static fetchDocLibrary = fetchDocLibrary;
    static addQuizSettings = addQuizSettings;
    static uploadSlides = uploadSlides;
    static addGameType = addGameType;
}

export default DeckEditorAction;
